import { oAuthParams } from '../../../models/index';
import { PartnerId } from '../../../models/Integration';
import { redirectURI } from './redirectURI';

const PESSL_AUTH_URL = import.meta.env.VITE_APP_PESSL_AUTH_URL;
const PESSL_CLIENT_ID = import.meta.env.VITE_APP_PESSL_CLIENT_ID;
const AGFINITI_AUTH_URL = import.meta.env.VITE_APP_AGFINITI_AUTH_URL;
const AGFINITI_CLIENT_ID = import.meta.env.VITE_APP_AGFINITI_CLIENT_ID;
const FARMOBILE_AUTH_URL = import.meta.env.VITE_APP_FARMOBILE_AUTH_URL;
const FARMOBILE_CLIENT_ID = import.meta.env.VITE_APP_FARMOBILE_CLIENT_ID;

export const getPartnerOAuthSettings = (partnerId: string): oAuthParams | null => {
  const defaultParams = {
    redirect_uri: redirectURI(partnerId),
    response_type: 'code',
  };
  switch (partnerId) {
    case PartnerId.Pessl:
      return {
        apiUrl: PESSL_AUTH_URL,
        params: {
          ...defaultParams,
          client_id: PESSL_CLIENT_ID,
          state: 'xyz',
        },
      };
    case PartnerId.AgFiniti:
      return {
        apiUrl: AGFINITI_AUTH_URL,
        params: {
          ...defaultParams,
          client_id: AGFINITI_CLIENT_ID,
          scope: 'filedownload fileupload openid',
        },
      };
    case PartnerId.Farmobile:
      let _oauthParams: oAuthParams = {
        apiUrl: FARMOBILE_AUTH_URL,
        params: {
          ...defaultParams,
          client_id: FARMOBILE_CLIENT_ID,
          scope: 'read+write',
        },
      };
      delete _oauthParams.params.redirect_uri;
      return _oauthParams;

    default:
      return null;
  }
};
